import type { ReactNode } from 'react'
import { type StyleProp, StyleSheet, type ViewStyle } from 'react-native'
import { Dialog, Portal, useTheme } from 'react-native-paper'
import { useDismissOnEscape } from '@/hooks/useDismissOnEscape'

interface PickerDialogProps {
    visible: boolean
    onDismiss: () => void
    children: ReactNode
    style?: StyleProp<ViewStyle>
}

export function PickerDialog({ visible, onDismiss, children, style }: PickerDialogProps) {
    const theme = useTheme()
    useDismissOnEscape(visible, onDismiss)

    return (
        <Portal>
            <Dialog
                visible={visible}
                onDismiss={onDismiss}
                style={[
                    styles.dialog,
                    {
                        backgroundColor: theme.colors.surface,
                        borderColor: theme.colors.outline,
                    },
                    style,
                ]}
            >
                {children}
            </Dialog>
        </Portal>
    )
}

const styles = StyleSheet.create({
    dialog: {
        borderWidth: 1,
        borderRadius: 8,
        width: '90%',
        maxWidth: 500,
        alignSelf: 'center',
    },
})
